import * as _ from 'lodash';
import * as React from 'react';
import { Svg } from 'src/components/shared/Svg';
import { IFile } from 'src/model';
import { getPropositionFileUrl } from 'src/services';

interface IProjectCardPropositionFileItemProps {
  file: IFile;
  propositionId: string;
}

interface IProjectCardPropositionFileItemState {
  fileUrl: string;
}

export class ProjectCardPropositionFileItem extends React.Component<
  IProjectCardPropositionFileItemProps,
  IProjectCardPropositionFileItemState
> {
  constructor(props: IProjectCardPropositionFileItemProps) {
    super(props);
    this.state = {
      fileUrl: '',
    };
  }

  public async componentDidMount() {
    const { file, propositionId } = this.props;
    const fileUrl = await getPropositionFileUrl(propositionId, file.uuid);
    if (fileUrl) {
      this.setState(fileUrl);
    }
  }

  public render() {
    const { file } = this.props;
    const { fileUrl } = this.state;

    return (
      <a href={fileUrl} target='_blank' style={{ cursor: 'pointer' }}>
        <Svg className='mr-2' width={18} fill='white' src='attachment' />
        <span className='text-white'>{file.filename}</span>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPropositions/ProjectPropositionCard/ProjectPropositionCardFileItem.tsx